module.exports = __webpack_public_path__ + "9311d20.webp";